const localeText = {
  noColorLabel: "No Color",
  addColorTooltip: "Add Color",
  addColorDisabledTooltip: "Color limit reached, delete a color to add more.",
  pickerAdornmentTooltip: "Copy to clipboard",
  pickerAdornmentTooltipCopied: "Copied",
  footerButtonCancel: "Cancel",
  footerButtonCommit: "Save",
  footerButtonAddColor: "Add Color",
  tabPaletteLabel: "Palette",
  tabCustomLabel: "Custom",
  deleteColorTooltip: "Delete Color",
  randomColorActionTooltip: "Random Color",
  triggerSelectLabel: "Select trigger label",
  triggerButtonLabel: "Button trigger label"
};
export {
  localeText
};
//# sourceMappingURL=localeText.js.map
